import {
  AddLocationsToGroupMutationOptions,
  LocationGroupCreateMutationOptions,
  LocationGroupUpdateMutationOptions,
  RemoveLocationsFromGroupMutationOptions,
  useAddLocationsToGroupMutation as useApolloAddLocationsToGroupMutation,
  useLocationGroupCreateMutation as useApolloLocationGroupCreateMutation,
  useLocationGroupUpdateMutation as useApolloLocationGroupUpdateMutation,
  useRemoveLocationsFromGroupMutation as useApolloRemoveLocationsFromGroupMutation,
} from '@occc/graphql';

import { useMutation } from '../utils';

export const useLocationGroupCreateMutation = (baseOptions: LocationGroupCreateMutationOptions) =>
  useMutation(useApolloLocationGroupCreateMutation, baseOptions);

export const useLocationGroupUpdateMutation = (baseOptions: LocationGroupUpdateMutationOptions) =>
  useMutation(useApolloLocationGroupUpdateMutation, baseOptions);

export const useAddLocationsToGroupMutation = (baseOptions: AddLocationsToGroupMutationOptions) =>
  useMutation(useApolloAddLocationsToGroupMutation, baseOptions);

export const useRemoveLocationsFromGroupMutation = (
  baseOptions: RemoveLocationsFromGroupMutationOptions,
) => useMutation(useApolloRemoveLocationsFromGroupMutation, baseOptions);
